import React, { Component } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableHighlight,
  TextInput,
  Platform,
  Dimensions,
  Alert,
} from 'react-native';
import {StyleContext} from '../styleC';
import strings from '../strings';
import info from '../info';
import CommonActions from "./CommonActions";
import firebase from './firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue, limitToFirst, startAt, endAt, query} from "firebase/database";

import example from '../example';
import MavTextInput from './mavTextInput';
import MavButton from './mavButton';
import MavAlert from './mavAlert';
import MavViewMore from './mavViewMore';
import MavNavigationMinimize from './mavNavigationMinimize';
import AfterRacePay from './afterRacePay';

const timer = require('react-native-timer');

export default class account extends Component {
  constructor(props) {
    super(props);

    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;    



     var estimatePriceCalcFinal=params.data.estimatePrice
     var driverPrice=params.data.driverPrice;
     driverPrice=driverPrice.replace(params.data.money.symbole,"")
     driverPrice=parseFloat(driverPrice);

     
     console.log("params.data.driverPlaceInfoAdmin "+params.data.driverPlaceInfoAdmin)
    this.state={ 

      paymentDriverMode:params.data.paymentDriverMode,
      alreadyPaid:params.data.alreadyPaid,
      hidePriceRaceForDriver:params.data.hidePriceRaceForDriver,
      partner:params.data.partner,
      driver:params.data.driver,
      privilegeDriver:params.data.privilegeDriver,
      providerID:params.data.providerID,
      providerName:params.data.providerName,
      providerLastName:params.data.providerLastName,
      racePlaceStartName:params.data.racePlaceStartName,
      racePlaceEndName:params.data.racePlaceEndName,
      clientName:params.data.clientName,
      description:params.data.description,
      customerPro:params.data.customerPro,
      providerBill:params.data.providerBill, 
      customerProName:params.data.customerProName,
      customerProEmail:params.data.customerProEmail,
      customerProLastName:params.data.customerProLastName,
      customerProEnterprise:params.data.customerProEnterprise,
      customerProAdressBill:params.data.customerProAdressBill,
      customerProCityBill:params.data.customerProCityBill,
      providerAdressBill:params.data.providerAdressBill,
      providerCityBill:params.data.providerCityBill,
      clientAdressBill:params.data.clientAdressBill,
      clientCityBill:params.data.clientCityBill,
      clientEnterprise:params.data.clientEnterprise,
      providerEnterprise:params.data.providerEnterprise,
      carName:params.data.carName,
      clientID:params.data.clientID,
      charge:params.data.charge,
      chargeAfterRace:params.data.chargeAfterRace,
      deferredPayment:params.data.deferredPayment,
      money:params.data.money,
      addDriverPrice:params.data.addDriverPrice,
      clientLastName:params.data.clientLastName,
      suggestedDelay:params.suggestedDelay,
      clientPhone:params.data.clientPhone,
      clientEmail:params.data.clientEmail,
      status:params.data.status,
      noVAT:params.data.noVAT,
      estimatePrice:estimatePriceCalcFinal,
      estimateTimeValue:(params.data.estimateTimeValue/60).toString(),
      raceDate:params.data.raceDate,
      estimateKm:params.data.estimateKm,
      driverPrice:driverPrice,
      id:params.data.id,
      orderDate:params.data.orderDate,
      racePlaceEndNameOnStart:params.data.racePlaceEndName,
      driverPlaceInfoAdmin:params.data.driverPlaceInfoAdmin, 
      karhooProvider:params.data.karhooProvider,
      viewDriverPlaceInfoAdmin:(params.data.driverPlaceInfoAdmin!=undefined && params.data.driverPlaceInfoAdmin!=false)?true:false,
      date:((new Date(params.data.raceDate).getDate()<10)?"0":"")+new Date(params.data.raceDate).getDate()+"/"+(((new Date(params.data.raceDate).getMonth()+1)<10)?"0":"")+(new Date(params.data.raceDate).getMonth()+1)+"/"+new Date(params.data.raceDate).getFullYear()+" - "+((new Date(params.data.raceDate).getHours()<10)?"0":"")+new Date(params.data.raceDate).getHours()+":"+((new Date(params.data.raceDate).getMinutes()<10)?"0":"")+ new Date(params.data.raceDate).getMinutes(),
      companyBrand:info.companyBrand,
      companyAdress:info.companyAdress,
      companyCity:info.companyCity,
      companyPhone:info.companyPhone,
      companyEmail:info.companyEmail,
      forcePaymentOnBoard:"",
      notes:"",
      waiting:false,
      applyFeeDelay:false,
      waitingPrice:{
          pricePerMinuteTTC:"",
          minute:"",
      }


    }

  }


 
componentDidMount(){
  var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;  

  if (getAuth(firebase).currentUser != null && params.data.attributedPartner==undefined) {
      firebase.database().ref('/users/' + getAuth(firebase).currentUser.uid).once('value').then(value => {
        var val = value.val();
        this.setState({driverName:val.name+" "+val.lastName});
      });
    }
    else if(params.data.attributedPartner!=undefined) this.setState({driverName:params.data.attributedPartner.text})

    
}

verifyCharge(){
  var newPrice=parseFloat(this.state.estimatePrice.toString().replace(this.state.money.symbole,''));



  if(this.state.applyFeeDelay===true) newPrice+=parseFloat( this.state.waitingPrice.pricePerMinuteTTC.toString().replace(this.state.money.symbole,''))*parseFloat(this.state.waitingPrice.minute)

  if(this.state.karhooProvider==true) this.sendBill()
  else if(this.state.charge!=undefined && this.state.charge.amount!=newPrice && this.state.chargeAfterRace==undefined){
    if(newPrice>this.state.charge.amount) {
      var somme=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+(newPrice-this.state.charge.amount)+((this.state.money.position=="right")?(this.state.money.symbole):""); 
      var avancedList=[{text: strings.paiementOnBoard,bottomText:(info.paiementOnBoardCard==true)?strings.paymentCash:undefined, help:strings.paiementOnBoardMoreInfo,onPress: () => {this.sendBill()}}];
      if(info.paiementOnBoardCard==true) avancedList.push({ help:strings.paiementOnBoardCardMoreInfo, text:strings.paiementOnBoard,bottomText:strings.paymentCard ,onPress: () => {this.sendBill("cardOnBoard")}} )





      if(this.state.providerID==undefined && this.state.customerPro!=true && info.stripePublicKey!=undefined && info.noSendMailAfterBill!=true) avancedList.push({bottomText:strings.withBill, help:strings.withBillMoreInfo,text:strings.linkPayment ,onPress: () => {this.sendBill(true,(newPrice-this.state.charge.amount))}} )
      if(this.state.providerID==undefined && info.paymentCardApp==true && this.state.customerPro!=true) avancedList.push({bottomText:strings.inApp,help:strings.inAppMoreInfo,text:strings.payment ,onPress: () => { this.afterRacePay.onInfo({driver:true, raceID:this.state.id, amount:(newPrice-this.state.charge.amount),currency:this.state.money, clientID:this.state.clientID }) }} )
      
      if(avancedList.length>1){
        avancedList.push({text: strings.cancel,style:"cancel", onPress: () => {}})
        this.alert.onAlert({largeButton:true, title:strings.userPaidLower+"\n"+strings.amountPaid+" : "+somme,subTitle:strings.whatDoing,buttons:avancedList});
      }

      else this.alert.onAlert({title:strings.userPaidLower+"\n"+strings.amountPaid+" : "+somme,subTitle:strings.paidOnBoard,buttons:[
          {text: strings.yes,onPress: () => {this.sendBill()}},
          {text: strings.cancel,style:"cancel",onPress: () => {}},
          ]});
      
    }
    else{

      var somme=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+(this.state.charge.amount-newPrice)+((this.state.money.position=="right")?(this.state.money.symbole):""); 

      this.alert.onAlert({title:strings.userPaidHighter+" ("+somme+")",subTitle:strings.userAlreadyPaidRefundQuetionPart2,buttons:[
          {text: strings.yes,onPress: () => {this.sendRefundRequest(); this.sendBill()}},
          {text: strings.cancel,style:"cancel",onPress: () => {}},
          ]});

     

    }

      

  }
  else if(this.state.deferredPayment!=true && this.state.charge==undefined && this.state.chargeAfterRace==undefined && this.state.alreadyPaid!=true && (this.state.paymentDriverMode!="onlyDriver" && this.state.paymentDriverMode!="driverAndClient")){
    
    var avancedList=[{text: strings.paiementOnBoard, bottomText:(info.paiementOnBoardCard==true)?strings.paymentCash:undefined, help:strings.paiementOnBoardMoreInfo,onPress: () => {this.sendBill()}}];
    if(info.paiementOnBoardCard==true) avancedList.push({help:strings.paiementOnBoardCardMoreInfo, text:strings.paiementOnBoard,bottomText:strings.paymentCard,onPress: () => {this.sendBill("cardOnBoard")}} )
    if(this.state.providerID==undefined && this.state.customerPro!=true && info.stripePublicKey!=undefined && info.noSendMailAfterBill!=true) avancedList.push({bottomText:strings.withBill, help:strings.withBillMoreInfo, text:strings.linkPayment ,onPress: () => {this.sendBill(true,newPrice)}} )
    if(this.state.providerID==undefined && info.paymentCardApp==true && this.state.customerPro!=true) avancedList.push({bottomText:strings.inApp, help:strings.inAppMoreInfo,text:strings.payment ,onPress: () => { this.afterRacePay.onInfo({driver:true, raceID:this.state.id, amount:newPrice,currency:this.state.money, clientID:this.state.clientID }) }} )
    
    if(avancedList.length>1){

      avancedList.push({text: strings.cancel,style:"cancel", onPress: () => {}})
      this.alert.onAlert({largeButton:true, title:strings.clientNotActualyPaid,subTitle:strings.whatDoing,buttons:avancedList, help:{enable:true, title:strings.payment, subTitle:strings.necessairePaid }  });
    }
    else this.alert.onAlert({title:strings.clientNotActualyPaid,subTitle:strings.continueQuestion,buttons:[
          {text: strings.yes,onPress: () => {this.sendBill()}},
          {text: strings.cancel,style:"cancel", onPress: () => {}},
          ]});
   
  } 
  else this.sendBill()

}

sendBill= (withLink, linkPrice) => { 
  var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;  
                  var error=false;

                  var date=this.state.date;
                      date=new Date(date[6]+date[7]+date[8]+date[9]+'-'+date[3]+date[4]+'-'+date[0]+date[1]+'T'+date[13]+date[14]+':'+date[16]+date[17]+':00')
                      date=Date.parse(date)+date.getTimezoneOffset()*60000;

                    var raceDateFixed=new Date(date);
                    raceDateFixed=((raceDateFixed.getDate()<10)?"0":"")+raceDateFixed.getDate()+"/"+(((raceDateFixed.getMonth()+1)<10)?"0":"")+(raceDateFixed.getMonth()+1)+"/"+raceDateFixed.getFullYear()+" - "+((raceDateFixed.getHours()<10)?"0":"")+raceDateFixed.getHours()+"h"+((raceDateFixed.getMinutes()<10)?"0":"")+raceDateFixed.getMinutes();
                    
                    var orderDateFixed=new Date();
                    orderDateFixed=((orderDateFixed.getDate()<10)?"0":"")+orderDateFixed.getDate()+"/"+(((orderDateFixed.getMonth()+1)<10)?"0":"")+(orderDateFixed.getMonth()+1)+"/"+orderDateFixed.getFullYear();

                    var newPrice=parseFloat(this.state.estimatePrice.toString().replace(this.state.money.symbole,''));
                    if(this.state.applyFeeDelay===true) newPrice+=parseFloat(this.state.waitingPrice.pricePerMinuteTTC.toString().replace(this.state.money.symbole,''))*parseFloat(this.state.waitingPrice.minute)

                    



                  var sendToFirebase={
                    racePlaceStartName:(this.state.racePlaceStartName!=undefined)?this.state.racePlaceStartName:"",
                    clientName:(this.state.clientName!=undefined)?this.state.clientName:"",
                    clientLastName:(this.state.clientLastName!=undefined)?this.state.clientLastName:"",
                    clientPhone:(this.state.clientPhone!=undefined)?this.state.clientPhone:"",
                    carName:(this.state.carName!=undefined)?this.state.carName:"",
                    description:(this.state.description!=undefined)?this.state.description:"",
                    orderDate:this.state.orderDate,
                    orderDateFixed:orderDateFixed,
                    estimatePrice:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+newPrice+((this.state.money.position=="right")?(this.state.money.symbole):""),
                    finalPrice:newPrice,
                    
                    driverName:this.state.driverName,
                    estimateTimeValue:parseInt(this.state.estimateTimeValue*60),
                    status:"WaitingInvoice",
                    notes:this.state.notes,

                  }
                  if(this.state.clientEmail!=undefined && this.state.clientEmail!="") sendToFirebase.clientEmail=this.state.clientEmail;

                  if(withLink==true) {
                      sendToFirebase.withPaymentLink=true;
                      sendToFirebase.stripePublicKey=info.stripePublicKey;
                      sendToFirebase.currency=this.state.money.stripeCode;
                      sendToFirebase.linkPrice=linkPrice;

                    }
                  if(withLink=="cardOnBoard") sendToFirebase.cardOnBoard=true; 

                  /*c'est ici qu'on calcul le montant finale de la commission chauffeur */
                  var driverPlaceInfoAdmin =(this.state.viewDriverPlaceInfoAdmin==true)?(parseFloat(this.state.driverPlaceInfoAdmin.toString().replace(this.state.money.symbole,''))):false; 
                  if(driverPlaceInfoAdmin!=false){
                    if(isNaN(driverPlaceInfoAdmin)) error=strings.priceBillError;
                    else sendToFirebase.finalPriceDriverTTCEstimate=driverPlaceInfoAdmin; 
                  } 

                  else if(params.commission!=undefined && params.commission.calculateCommission==true){
                      var driverPrice=parseFloat(newPrice);
                      console.log("je suis ici lol")
                      console.log("this.state.addDriverPrice "+this.state.addDriverPrice)
                      if(this.state.addDriverPrice!=undefined) {driverPrice+=this.state.addDriverPrice; } 
                      console.log("driverPrice "+driverPrice)
                      if(params.commission.addCommissionFixe===true && params.commission.addCommissionFixeAmount>0) driverPrice-=params.commission.addCommissionFixeAmount;
                      if(params.commission.addCommissionVariable===true && params.commission.addCommissionVariableAmount>0) driverPrice=driverPrice*((100-params.commission.addCommissionVariableAmount)/100);
                      if(params.commission.commissionDriver>0) driverPrice=driverPrice*((100-params.commission.commissionDriver)/100);
                      driverPrice=parseFloat(parseFloat(driverPrice).toFixed(2));
                      sendToFirebase.finalPriceDriverTTCEstimate=driverPrice;

                  }


                  if(this.state.applyFeeDelay===true){
                    sendToFirebase.waitingPrice={pricePerMinuteTTC:parseFloat( this.state.waitingPrice.pricePerMinuteTTC.toString().replace(this.state.money.symbole,'')),minute:parseFloat(this.state.waitingPrice.minute)};
                  }


                  if(this.state.clientID!="" && this.state.clientID!=undefined) sendToFirebase.clientID=this.state.clientID

                  if(this.state.forcePaymentOnBoard!="Paiement à bord du véhicule" && this.state.forcePaymentOnBoard!="" && this.state.forcePaymentOnBoard!="Paiement : à bord du véhicule") sendToFirebase.fpob=this.state.forcePaymentOnBoard



                  if(this.state.racePlaceEndNameOnStart=="" || this.state.racePlaceEndNameOnStart==undefined){
                    sendToFirebase.timeValue=parseInt(this.state.estimateTimeValue*60)
                  }
                  else sendToFirebase.racePlaceEndName=this.state.racePlaceEndName

                  

                  if(sendToFirebase.clientLastName=="" || sendToFirebase.clientName=="") error=strings.clientNameError
                  
                  else if((this.state.racePlaceEndNameOnStart=="" || this.state.racePlaceEndNameOnStart==undefined) && (isNaN(sendToFirebase.timeValue) || sendToFirebase.timeValue==0)) error=strings.timeBillError
                  else if(sendToFirebase.racePlaceStartName=="") error=strings.startBillError
                  else if(this.state.racePlaceEndNameOnStart!="" && this.state.racePlaceEndNameOnStart!=undefined && sendToFirebase.racePlaceEndName=="") error=strings.endBillError
                  else if(sendToFirebase.estimatePrice=="" || isNaN(sendToFirebase.finalPrice)) error=strings.priceBillError 


                  
                  if(this.state.customerPro!=true && this.state.providerBill!=true && this.state.deferredPayment!=true){
                      sendToFirebase.clientEnterprise=(this.state.clientEnterprise!=undefined && this.state.clientEnterprise!="")?this.state.clientEnterprise:null;
                      sendToFirebase.clientAdressBill=(this.state.clientAdressBill!=undefined && this.state.clientAdressBill!="")?this.state.clientAdressBill:null;
                      sendToFirebase.clientCityBill=(this.state.clientCityBill!=undefined && this.state.clientCityBill!="")?this.state.clientCityBill:null;
                  }

                  else if(this.state.customerPro==true && this.state.deferredPayment!=true){
                    sendToFirebase.customerProEnterprise=(this.state.customerProEnterprise!=undefined && this.state.customerProEnterprise!="")?this.state.customerProEnterprise:null;
                    sendToFirebase.customerProName=(this.state.customerProName!=undefined && this.state.customerProName!="")?this.state.customerProName:null;
                    sendToFirebase.customerProLastName=(this.state.customerProLastName!=undefined && this.state.customerProLastName!="")?this.state.customerProLastName:null;
                    sendToFirebase.customerProEmail=(this.state.customerProEmail!=undefined && this.state.customerProEmail!="")?this.state.customerProEmail:null;
                    sendToFirebase.customerProAdressBill=(this.state.customerProAdressBill!=undefined && this.state.customerProAdressBill!="")?this.state.customerProAdressBill:null;
                    sendToFirebase.customerProCityBill=(this.state.customerProCityBill!=undefined && this.state.customerProCityBill!="")?this.state.customerProCityBill:null;

                  } else if(this.state.customerPro!=true && this.state.providerBill==true && this.state.deferredPayment!=true){
                    sendToFirebase.providerEnterprise=(this.state.providerEnterprise!=undefined && this.state.providerEnterprise!="")?this.state.providerEnterprise:null;
                    sendToFirebase.providerName=(this.state.providerName!=undefined && this.state.providerName!="")?this.state.providerName:null;
                    sendToFirebase.providerLastName=(this.state.providerLastName!=undefined && this.state.providerLastName!="")?this.state.providerLastName:null;
                    sendToFirebase.providerEmail=(this.state.providerEmail!=undefined && this.state.providerEmail!="")?this.state.providerEmail:null;
                    sendToFirebase.providerAdressBill=(this.state.providerAdressBill!=undefined && this.state.providerAdressBill!="")?this.state.providerAdressBill:null;
                    sendToFirebase.providerCityBill=(this.state.providerCityBill!=undefined && this.state.providerCityBill!="")?this.state.providerCityBill:null;

                  }



                  if(error!=false) this.alert.onAlert({title:error}); 
                  else {
                  
                  console.log(sendToFirebase);
                  const fireInfo={} 
                  for (const [key, value] of Object.entries(sendToFirebase)) {
                  fireInfo['race/' +this.state.id+"/"+key]=value;
                  }
                  update(ref(getDatabase(firebase)), fireInfo)

                  

                   
                    this.alert.onAlert({title:(this.state.deferredPayment==true)?strings.billGenerateWithDeferredPayment:strings.billEnd,buttons:[{text:strings.ok,onPress: () => {
                     if(Platform.OS=="web") this.props.params.goBack(true);
                     else this.props.navigation.dispatch(CommonActions.reset({index: 0,routes: [{ name: 'Main' },],}) );

                    }}],});

                    

                    

                    
                  }
}

 sendRefundRequest(){
  if(this.state.chargeAfterRace!=undefined) Alert.onAlert({title:"Impossible de rembourser. Utilisez Stripe directement"})
  else {

    var refurn=-1;
    if(this.state.charge.capture==="stripeError") refurn=this.state.charge.creditAmount-parseInt(this.state.estimatePrice)
    else refurn=this.state.charge.amount-parseInt(this.state.estimatePrice);
      
      getAuth(firebase).currentUser.getIdToken().then(token => {
                var body={
                    userID:getAuth(firebase).currentUser.uid,
                    bundleIdentifer:info.bundleIdentifer,
                    partialRefurn:refurn,
                    chargeID:this.state.charge.chargeID,
                    token:token,
                    bundleAdress:info.firebaseProjectID,
                }
                body=JSON.stringify(body);
      
                if(refurn>0) fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/refundRace", {
                        body: body,
                        headers: {"Content-Type": "application/json"},method: "POST"}).then(response => {
                          console.log(response)
                     }).catch((err) => { console.log("error sendRefundRequest"); console.log(err); timer.setTimeout("sendRefundRequest", () => { this.sendRefundRequest();  }, 2000);   })

        })

  }
  


  }



  render() {
    return (
      <StyleContext.Consumer>{style => 
      <ScrollView style={{ marginLeft: 0, marginRight: 0, backgroundColor: style.backgroundColor }}>

            {(Platform.OS=="web") && <MavNavigationMinimize clickLeft={() => { var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params; params.goBack();  }} left={strings.return} title={ strings.generateBill } />}


            <Text style={{marginTop:10,marginLeft:"10%", marginRight:"10%",color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center"}}>{strings.billCaution}</Text>

             <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.principalCustomer}</Text>
        

             <MavViewMore text={this.state.clientName+" "+this.state.clientLastName} iconClassic={(style.mode=="dark")?require('../assets/user_white.png'):require('../assets/user_black.png')} disable={!(this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" )))}>


                 <MavTextInput style={{marginTop:15}} backgroundColor={style.backgroundColorContrast} text={this.state.clientName} textExplication={strings.name} textInputFlex={2} placeholder={example.name} onChangeText={(text)=>{this.setState({clientName: text })}}/>
                 <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} disableLine={!(this.state.customerPro!=true && this.state.providerBill!=true && this.state.deferredPayment!=true)} text={this.state.clientLastName} textExplication={strings.lastName} textInputFlex={2} placeholder={example.lastName} onChangeText={(text)=>{this.setState({clientLastName: text })}}/>
                 
                 {(this.state.customerPro!=true && this.state.providerBill!=true && this.state.deferredPayment!=true) && <MavTextInput backgroundColor={style.backgroundColorContrast} style={{marginTop:5}} text={this.state.clientEmail} editable={true} textExplication={strings.email} textInputFlex={2} placeholder={example.email} onChangeText={(text)=>{this.setState({clientEmail: text })}}/>}
                 
                 {(this.state.customerPro!=true && this.state.providerBill!=true && this.state.deferredPayment!=true) && <MavTextInput backgroundColor={style.backgroundColorContrast} style={{marginTop:5}} text={(this.state.clientEnterprise!=undefined)?this.state.clientEnterprise:""} editable={true} textExplication={strings.enterprise} textInputFlex={2} placeholder={example.company} onChangeText={(text)=>{this.setState({clientEnterprise: text })}}/>}                 
                 {(this.state.customerPro!=true && this.state.providerBill!=true && this.state.deferredPayment!=true) && <MavTextInput backgroundColor={style.backgroundColorContrast} style={{marginTop:5}} text={(this.state.clientAdressBill!=undefined)?this.state.clientAdressBill:""} editable={true} textExplication={strings.adressBill} textInputFlex={2} placeholder={example.adress} onChangeText={(text)=>{this.setState({clientAdressBill: text })}}/>}                 
                 {(this.state.customerPro!=true && this.state.providerBill!=true && this.state.deferredPayment!=true) && <MavTextInput backgroundColor={style.backgroundColorContrast} style={{marginTop:5}} text={(this.state.clientCityBill!=undefined)?this.state.clientCityBill:""} disableLine={true} editable={true} textExplication={strings.cityBill} textInputFlex={2} placeholder={info.companyCity} onChangeText={(text)=>{this.setState({clientCityBill: text })}}/>}
                 
             </MavViewMore>


             {(this.state.customerPro==true || this.state.providerBill==true) && <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.buyerInfos}</Text>}

             {((this.state.customerPro==true || this.state.providerBill==true) && this.state.deferredPayment==true) && <Text style={{color: style.colorValidate,fontSize: style.textInputFontSize*0.9,textAlign: "center",}}>{"("+strings.deferredPayment+")"}</Text>}

             {this.state.customerPro==true && <MavViewMore text={(this.state.customerProEnterprise!=undefined)?this.state.customerProEnterprise:(this.state.customerProName+" "+this.state.customerProLastName)} iconClassic={(style.mode=="dark")?require('../assets/user_white.png'):require('../assets/user_black.png')} disable={(this.state.deferredPayment==true)?true:(!(this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max") )))}>
                     <MavTextInput backgroundColor={style.backgroundColorContrast} style={{marginTop:15}} text={(this.state.customerProEnterprise!=undefined)?this.state.customerProEnterprise:""} editable={true} textExplication={strings.enterprise} textInputFlex={2} placeholder={"Ma Sociéte SAS"} onChangeText={(text)=>{this.setState({customerProEnterprise: text })}}/>
                    <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.customerProName} textExplication={strings.name} textInputFlex={2} placeholder={example.name} onChangeText={(text)=>{this.setState({customerProName: text })}}/>
                    <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.customerProLastName} textExplication={strings.lastName} textInputFlex={2} placeholder={example.lastName} onChangeText={(text)=>{this.setState({customerProLastName: text })}}/>
                    <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.customerProEmail} textExplication={strings.email} textInputFlex={2} placeholder={example.email} onChangeText={(text)=>{this.setState({customerProEmail: text })}}/>

                    <MavTextInput backgroundColor={style.backgroundColorContrast} style={{marginTop:5}} text={(this.state.customerProAdressBill!=undefined)?this.state.customerProAdressBill:""} editable={true} textExplication={strings.adressBill} textInputFlex={2} placeholder={example.adress} onChangeText={(text)=>{this.setState({customerProAdressBill: text })}}/>                
                    <MavTextInput backgroundColor={style.backgroundColorContrast} style={{marginTop:5}} text={(this.state.customerProCityBill!=undefined)?this.state.customerProCityBill:""} disableLine={true} editable={true} textExplication={strings.cityBill} textInputFlex={2} placeholder={info.companyCity} onChangeText={(text)=>{this.setState({customerProCityBill: text })}}/>

             </MavViewMore>}


             {(this.state.customerPro!=true && this.state.providerBill==true) && <MavViewMore text={(this.state.providerEnterprise!=undefined)?this.state.providerEnterprise:(this.state.providerName+" "+this.state.providerLastName)} iconClassic={(style.mode=="dark")?require('../assets/user_white.png'):require('../assets/user_black.png')} disable={(this.state.deferredPayment==true)?true:(!(this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max") )))}>
                     <MavTextInput backgroundColor={style.backgroundColorContrast} style={{marginTop:15}} text={(this.state.providerEnterprise!=undefined)?this.state.providerEnterprise:""} editable={true} textExplication={strings.enterprise} textInputFlex={2} placeholder={"Ma Sociéte SAS"} onChangeText={(text)=>{this.setState({providerEnterprise: text })}}/>
                    <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.providerName} textExplication={strings.name} textInputFlex={2} placeholder={example.name} onChangeText={(text)=>{this.setState({providerName: text })}}/>
                    <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.providerLastName} textExplication={strings.lastName} textInputFlex={2} placeholder={example.lastName} onChangeText={(text)=>{this.setState({providerLastName: text })}}/>
                    <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.providerEmail} textExplication={strings.email} textInputFlex={2} placeholder={example.company} onChangeText={(text)=>{this.setState({providerEmail: text })}}/>
                    <MavTextInput backgroundColor={style.backgroundColorContrast} style={{marginTop:5}} text={(this.state.providerAdressBill!=undefined)?this.state.providerAdressBill:""} editable={true} textExplication={strings.adressBill} textInputFlex={2} placeholder={example.adress} onChangeText={(text)=>{this.setState({providerAdressBill: text })}}/>                
                    <MavTextInput backgroundColor={style.backgroundColorContrast} style={{marginTop:5}} text={(this.state.providerCityBill!=undefined)?this.state.providerCityBill:""} disableLine={true} editable={true} textExplication={strings.cityBill} textInputFlex={2} placeholder={info.companyCity} onChangeText={(text)=>{this.setState({providerCityBill: text })}}/>

             </MavViewMore>}





             {(this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" ))) && <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.feeDelay}</Text>}
            
             {((this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" ))) && (this.state.suggestedDelay!=undefined && this.state.suggestedDelay>3)) && <Text style={{marginTop:5,color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center",}}>{strings.clientHasDelay+" "+this.state.suggestedDelay+" "+strings.delayMinute.toLowerCase()}</Text>}


             {(this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" ))) && <MavViewMore arrow={true} text={strings.applyFeeDelay} onArrowChange={(value)=>{this.setState({applyFeeDelay:value}) }}>

                    <MavTextInput style={{marginTop:15}}  backgroundColor={style.backgroundColorContrast} keyboardType={"numeric"}  text={this.state.waitingPrice.minute} textExplication={strings.delayMinute} textInputFlex={2} placeholder={"1"} onChangeText={(text)=>{
                    var car=this.state.waitingPrice;
                    car.minute=text;
                    this.setState({waitingPrice: car })
                    }}/>

                   <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} disableLine={true}  keyboardType={"numeric"}  text={this.state.waitingPrice.pricePerMinuteTTC} textInputFlex={2} textExplication={strings.delayPriceMinute} placeholder={((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"1"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{
                    
                    timer.setTimeout(generateUUID(), () => {
                          var test=this.state.waitingPrice.pricePerMinuteTTC.indexOf(this.state.money.symbole);
                          if(test==-1 && this.state.waitingPrice.pricePerMinuteTTC!="") {
                            var car=this.state.waitingPrice;
                            car.pricePerMinuteTTC=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+car.pricePerMinuteTTC+((this.state.money.position=="right")?(this.state.money.symbole):"") 
                            this.setState({waitingPrice: car })
                          }
                      }, 2000);


                      text=text.toString().replace(this.state.money.symbole,'')
                      text=text.toString().replace(",",'.')
                      var car=this.state.waitingPrice;
                      car.pricePerMinuteTTC=text;
                      this.setState({waitingPrice: car })

                  }}/>


             </MavViewMore>}





             

            



             <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.raceInfo}</Text>

             {this.state.raceDate!=undefined && <MavTextInput style={{marginTop:15}} text={this.state.date == '' ? strings.dateAndHour : this.state.date} textInputFlex={2} textExplication={strings.startRace} editable={false} />} 


              <MavTextInput style={{marginTop:5}} text={this.state.racePlaceStartName} textInputFlex={2} textExplication={strings.start} editable={this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" ))} placeholder={"1 Avenue des Champs Elysée, 75000 Paris"} onChangeText={(text)=>{this.setState({racePlaceStartName: text })}}/>

              {(this.state.racePlaceEndNameOnStart!=undefined && this.state.racePlaceEndNameOnStart!="") && <MavTextInput textInputFlex={2} editable={this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" ))} style={{marginTop:5}} text={this.state.racePlaceEndName} textExplication={strings.destination} placeholder={"1 Avenue des Champs Elysée, 75000 Paris"} onChangeText={(text)=>{this.setState({racePlaceEndName: text })}}/>}

              {(this.state.racePlaceEndNameOnStart==undefined || this.state.racePlaceEndNameOnStart=="") && <MavTextInput textInputFlex={2} editable={this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" ))} style={{marginTop:5}} keyboardType={"numeric"} text={this.state.estimateTimeValue} textExplication={strings.durationInMinute} placeholder={"120"} onChangeText={(text)=>{this.setState({estimateTimeValue: text })}}/>}




              {(this.state.hidePriceRaceForDriver!=true || (this.state.deferredPayment!=true && this.state.karhooProvider!=true && this.state.charge==undefined && this.state.alreadyPaid!=true && (this.state.paymentDriverMode!="onlyDriver" && this.state.paymentDriverMode!="driverAndClient"))) && <MavTextInput style={{marginTop:5}} keyboardType={"numeric"} textInputFlex={2} editable={this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" ))} text={this.state.estimatePrice} textExplication={strings.price+((this.state.noVAT==true)?" HT":"")} placeholder={((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"50"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{

                timer.setTimeout(generateUUID(), () => {
                    var test=this.state.estimatePrice.indexOf(this.state.money.symbole);
                    if(test==-1 && this.state.estimatePrice!="") {
                      var car=this.state.estimatePrice;
                      car=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+car+((this.state.money.position=="right")?(this.state.money.symbole):"")
                      this.setState({estimatePrice:car}); 
                    }
                }, 2000);


                text=text.toString().replace(this.state.money.symbole,'')
                text=text.toString().replace(",",'.')
                this.setState({estimatePrice: text })




              }}/>}


              {(this.state.viewDriverPlaceInfoAdmin==true && this.state.driver==true) && <MavTextInput style={{marginTop:5}} keyboardType={"numeric"} textInputFlex={2} text={this.state.driverPlaceInfoAdmin} textExplication={strings.priceDriver} placeholder={((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"50"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{ 
                
                timer.setTimeout(generateUUID(), () => {
                    var test=this.state.driverPlaceInfoAdmin.indexOf(this.state.money.symbole);
                    if(test==-1 && this.state.driverPlaceInfoAdmin!="") {
                      var car=this.state.driverPlaceInfoAdmin;
                      car=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+car+((this.state.money.position=="right")?(this.state.money.symbole):"")
                      this.setState({driverPlaceInfoAdmin:car}); 
                    }
                }, 2000);


                text=text.toString().replace(this.state.money.symbole,'')
                text=text.toString().replace(",",'.')
                this.setState({driverPlaceInfoAdmin: text })

              }} />}


               {(((this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" ))) && this.state.deferredPayment!=true && this.state.charge==undefined && this.state.alreadyPaid!=true)) && <MavTextInput style={{marginTop:5}} textInputFlex={2}  text={this.state.forcePaymentOnBoard} textExplication={strings.forcePaymentOnBoard} placeholder={strings.textDefault} onChangeText={(text)=>{ this.setState({forcePaymentOnBoard:text})  }}/>}
              



              {(this.state.applyFeeDelay===true) && <MavTextInput  style={{marginTop:5}} textInputFlex={2} text={  ((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+(((parseFloat(this.state.estimatePrice.toString().replace(this.state.money.symbole,'')).toString()=="NaN")?0:parseFloat(this.state.estimatePrice.toString().replace(this.state.money.symbole,'')))+ (((parseFloat(this.state.waitingPrice.pricePerMinuteTTC.toString().replace(this.state.money.symbole,''))*parseInt(this.state.waitingPrice.minute)).toString()!="NaN")?(parseFloat(this.state.waitingPrice.pricePerMinuteTTC.toString().replace(this.state.money.symbole,''))*parseInt(this.state.waitingPrice.minute)):0) ).toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"") } textExplication={strings.priceAfterDelay} editable={false} />}

                {(true) && <MavTextInput style={{marginTop:15}} text={this.state.notes} multiline={true} textInputFlex={2} textExplication={strings.notes} placeholder={strings.otherInfoBill} onChangeText={(text)=>{this.setState({notes:text})}}/>}



              <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.driverInfo}</Text>


              <MavTextInput style={{marginTop:15}} editable={this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" ))} text={this.state.driverName} textInputFlex={2} textExplication={strings.driverLastName} placeholder={example.name+" "+example.lastName} onChangeText={(text)=>{this.setState({driverName: text })}}/>
                

              <View style={{alignItems:"center",justifyContent:"center", marginTop:50,marginBottom:50}}>
                  <MavButton text={strings.validate} onlyButton={true} onPress={()=>{  this.verifyCharge();   }}/>
              </View>

              


        

        
        
          
        <AfterRacePay params={{  sendBill: this.sendBill, }}  ref={afterRacePay => {this.afterRacePay = afterRacePay;}}/>
        
        <MavAlert ref={alert => {this.alert = alert;}}/>

      </ScrollView>
      }</StyleContext.Consumer>
    );
  }
}



export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}
